
import { Prop, Component, Vue, Watch } from "vue-property-decorator";

@Component
export default class VuePaginateComponent extends Vue {
  @Prop() public config;

  public activePage = 1;
  public changePage(page) {
    this.activePage = page;
    this.$emit("pageChange", this.activePage);
  }

  get showPrev() {
    if (this.config.currentPage == 1) {
      return false;
    } else {
      return true;
    }
  }

  get showNext() {
    if (this.config.currentPage == this.config.totalPages) {
      return false;
    } else {
      return true;
    }
  }
}
